<div>
  @if (!showDForm) {
    <app-chat></app-chat>
  }
  @if (showDForm) {
    <app-dynamic-forms> </app-dynamic-forms>
  }
  <!-- <router-outlet></router-outlet> -->
</div>